(() => {
  const PRODUCT_GALLERY_WIDTH = 1365;
  const PRODUCT_GALLERY_SELECTOR = 'media-gallery .product__media img';

  const gallerySizedUrl = (url) => {
    if (!url) return null;

    const parsed = new URL(url, window.location.origin);
    if (!parsed.pathname.includes('/cdn/shop/')) return null;

    parsed.searchParams.set('width', String(PRODUCT_GALLERY_WIDTH));
    return parsed.toString();
  };

  const preserveProductGalleryQuality = (image) => {
    if (!image.matches(PRODUCT_GALLERY_SELECTOR)) return;

    const targetUrl = gallerySizedUrl(image.currentSrc || image.src);
    if (!targetUrl) return;
    if (image.src === targetUrl && !image.hasAttribute('srcset') && !image.hasAttribute('sizes')) return;

    image.dataset.storewideSharp = 'true';
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = targetUrl;
  };

  const processProductGallery = (root = document) => {
    if (root instanceof HTMLImageElement) preserveProductGalleryQuality(root);
    root.querySelectorAll?.(PRODUCT_GALLERY_SELECTOR).forEach(preserveProductGalleryQuality);
  };

  const start = () => {
    processProductGallery();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLImageElement) {
          preserveProductGalleryQuality(mutation.target);
        }

        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) processProductGallery(node);
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'sizes'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
